{% block swag_cms_extensions_form_editor_settings_field_type_base %}
    {% block swag_cms_extensions_form_editor_settings_field_type_text_placeholder %}
        <mt-text-field
            v-model="placeholder"
            :label="$tc('swag-cms-extensions.sw-cms.components.form-editor.settings-field.placeholderFieldLabel')"
            size="medium"
        />
    {% endblock %}
{% endblock %}
